import clsx from 'clsx'

/**
 * Компактный skeleton-блок для первых рендеров detail-страниц, пока
 * React Query ещё не принёс данные. Мягче, чем полноэкранное
 * «Загрузка…»: каркас не прыгает, пользователь не теряет контекст.
 *
 * Использует tailwind `animate-pulse` + фон из токенов темы, чтобы не
 * нужен был дополнительный CSS.
 */
export function Skeleton({
  className,
  rounded = 'md',
}: {
  className?: string
  rounded?: 'sm' | 'md' | 'lg' | 'xl' | 'full'
}) {
  return (
    <div
      className={clsx(
        'animate-pulse bg-[color:var(--stryzh-color-border-subtle)]',
        rounded === 'sm' && 'rounded-[var(--stryzh-radius-sm)]',
        rounded === 'md' && 'rounded-[var(--stryzh-radius-md)]',
        rounded === 'lg' && 'rounded-[var(--stryzh-radius-lg)]',
        rounded === 'xl' && 'rounded-xl',
        rounded === 'full' && 'rounded-full',
        className,
      )}
    />
  )
}

/** Шапка detail-страницы: заголовок + подзаголовок + пара кнопок-заглушек. */
export function DetailHeaderSkeleton() {
  return (
    <header className="mb-6 flex flex-col gap-2">
      <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-3">
        <Skeleton className="h-9 w-64" />
        <div className="flex gap-2">
          <Skeleton className="h-9 w-28" />
          <Skeleton className="h-9 w-28" />
        </div>
      </div>
      <Skeleton className="h-4 w-40" />
    </header>
  )
}

/** Карточка-секция с парой «строк» данных. */
export function SectionSkeleton({
  lines = 4,
  className,
}: {
  lines?: number
  className?: string
}) {
  return (
    <section
      className={clsx(
        'rounded-xl border border-[var(--stryzh-color-border-default)] bg-[var(--stryzh-color-surface)] p-4',
        className,
      )}
    >
      <Skeleton className="mb-4 h-5 w-32" />
      <div className="grid gap-3">
        {Array.from({ length: lines }).map((_, i) => (
          <div key={i} className="grid gap-1">
            <Skeleton className="h-3 w-24" />
            <Skeleton className="h-4 w-full max-w-[320px]" />
          </div>
        ))}
      </div>
    </section>
  )
}
